import * as React from "react";

// Components
import GoPlayMarker from "./GoPlayMarker";
import GoPlayPopup from "./GoPlayPopup";

// Libraries
import Map, {NavigationControl} from "react-map-gl";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

/* eslint import/no-webpack-loader-syntax: off */
mapboxgl.workerClass =
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

export default function GoPlayMap(props) {

  // Selcted Event. Pick a map marker to select and event. The selected event detail is retrieved and used in the popup.
  const [selectedEvent, setSelectedEvent] = React.useState(null);

  // Event details from marker select
  const [eventDetail, setEventDetail] = React.useState([]);
  const [loadingEventDetail, setLoadingEventDetail] = React.useState(true);


  return (
    <>
      <div>
        {/*Goplay Events Map*/}
        <Map
          // Access token loaded from environment
          mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}

          // Set the style of the map. 
          mapStyle="mapbox://styles/mapbox/outdoors-v12"

          // See the folloring links for default styles
          // https://www-mapbox.webflow.io/gallery
          // https://docs.mapbox.com/api/maps/styles/

          // For a customized Map from Mapbox Studio:
          //mapStyle="mapbox://styles/linuxiscool/cl7j6dqtj002o14o8ute23pq7"

          // Additional custom styling of the map
          style={{ 
            //position: "absolute", 
            //top: 0, 
            //bottom: 0,
            width: "100%", 
            height: "100vh" 
          }}

          // Austin, Texas: 30.2672° N, 97.7431° W
          // "lng":-97.74468549028444,"lat":30.269625083772567
          // Set inital view coordinates and zoom level.
          initialViewState={{
            latitude: 30.2672,
            longitude: -97.7431,
            zoom: 2,
          }}

          // Customize the max bounds of the map
          maxBounds={ [
            [-333, -90], // West South 
            [333, 77] // East North
            ]}

          // Minimum and maximum zoom levels
          minZoom={1.2}
          maxZoom={15}

          dragRotate={false}

          // Map reference used across the app
          ref={props.mapRef}

          // This section tracks mouse coordinates.
          //onMouseMove={(e) =>
            //document.getElementById('info').innerHTML = JSON.stringify(e.point) +
              //'<br />' + JSON.stringify(e.lngLat.wrap())
          //}
          >

          {/* Uncomment to display mouse coordinates. */}
          {/* <pre id="info"></pre> */}

          {/* Render The Markers.  */}
          <GoPlayMarker 
            events={props.events} 
            selectedEvent={selectedEvent} 
            setSelectedEvent={setSelectedEvent} 
            setLoadingEventDetail={setLoadingEventDetail} 
            setEventDetail={setEventDetail}
            mapRef={props.mapRef}
          />

          {/* Event Selected. Loading Data... Display Popup  */}
          <GoPlayPopup 
            selectedEvent={selectedEvent}
            loadingEventDetail={loadingEventDetail}
            eventDetail={eventDetail}
            setSelectedEvent={setSelectedEvent}
          />
          <NavigationControl showCompass={false} />
        </Map>
      </div>
    </>
  );
}
